import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Datetime } from 'common/components/Datetime';
import { Chapter } from 'common/api/models/Chapter';
import { Member } from 'common/api/models/Member';
import { getExportUrl } from 'common/utils/api';

export interface ChaptersDetailInfoProps {
  chapter: Chapter;
  appState: AppState;
  members: Member[];
  admins: Member[];
}

export class ChaptersDetailInfo extends React.Component<ChaptersDetailInfoProps> {
  pluckMemberNames(data: Member[]) {
    let arr = [];
    for (var member of data) {
      arr.push(member.firstName + ' ' + member.lastName);
    }
    return arr.join(', ');
  }
  pluckAdminNames(data: Member[]) {
    let arr = [];
    for (var admin of data) {
      arr.push(admin.firstName + ' ' + admin.lastName);
    }
    return arr.join(', ');
  }
  render() {
    const chapter = this.props.chapter;
    const members = this.props.members;
    const admins = this.props.admins;

    return (
      <div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-2 text-right">
            <b>Name</b>
          </div>
          <div className="col">{chapter.name}</div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Region</b>
          </div>
          <div className="col">{chapter.region}</div>
        </div>
        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col-2 text-right">
            <b>Officers</b>
          </div>
          <div className="col">{members ? this.pluckMemberNames(members) : ' '}</div>
        </div>
        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col-2 text-right">
            <b>Admins</b>
          </div>
          <div className="col">{admins ? this.pluckAdminNames(admins) : ' '}</div>
        </div>
        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col-2 text-right">
            <b>Roster</b>
          </div>
          <div className="col">
            <a
              className="btn btn-primary btn-sm mr-2"
              href={getExportUrl(`/v2/member/chapter/${chapter.id}/export`)}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <i className="fa fa-download" />
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Created</b>
          </div>
          <div className="col">
            <Datetime at={chapter.createAt} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Updated</b>
          </div>
          <div className="col">
            <Datetime at={chapter.updateAt} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/ChaptersDetailInfo.tsx